var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{attrs:{"size":"xl","scrollable":false},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('KarinForm',{staticClass:"container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }